<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-8 col-xl-8 mb-3">
                            <h3 class="nk-block-title page-title">KYC Request</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} KYC Request.</p>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-3">
                            <input type="text" v-model="search" class="form-control" placeholder="Search by user or email..." />
                        </div>
                    </div>

                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                            <div class="card-inner p-0">
                                <table class="table table-orders">
                                    <thead>
                                        <tr class="tb-odr-item">
                                            <th class="tb-odr-info" style="width:50%;">
                                                <span class="tb-odr-id" style="width:150px;">User</span>
                                                <span class="tb-odr-id"  style="width:160px;">Email</span>
                                                <span class="tb-odr-date d-none d-md-inline-block">Registered Date</span>
                                            </th>
                                            <th class="tb-odr-amount">
                                                <span class="tb-odr-total"> Phone</span>
                                                <span class="tb-odr-status d-none d-md-inline-block">Submit Date</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="details in userList" v-bind:key="details.id" class="tb-odr-item">
                                            <td class="tb-odr-info" >
                                                <span class="tb-odr-id"  style="width:150px;"><a v-on:click="EditInfo(details.id)" href="javascript:void(0)">{{details.fullName}}</a></span>
                                                <span class="tb-odr-id"  style="width:160px;">{{details.email}}</span>
                                                <span class="tb-odr-date">{{details.date}}</span>
                                            </td>
                                            <td class="tb-odr-amount">
                                                <span class="tb-odr-total">
                                                    <span class="amount">{{details.phoneNumber}} </span>
                                                </span>
                                                <span class="tb-odr-status">
                                                    {{details.submitForApprovalDate}}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><!-- .card-inner -->
                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div><!-- .card-inner -->
                        </div><!-- .card-inner-group -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
    </div>



</template>
<script>
    export default {
        name: 'signUp',
        data: function () {
            return {
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: false,

                loading: false,
                userList: [],

                selected: [],
                selectAll: false,

                updateApprovalStatus: {
                    id: [],
                    approvalStatus: '',
                },

                user: {
                    id: '',
                    isActive: '',
                    isUser: true,
                },
            }
        },

        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },

        methods: {  
            UpdateApprovalStatus: function (id, isVerified) {
                var root = this;
                this.loading = true;
                
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/account/ApprovedRegisterUser?id=' + id + '&isVerified=' + isVerified, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data) {
                            root.loading = false;
                            root.$swal({
                                title: 'Updated!',
                                text: 'User Status has been Updated successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.getPage();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: "Something Went Wrong",
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },


            GetShortName: function (user) {
                var first = user.firstName.substr(0, 1);
                var second = user.lastName.substr(0, 1);
                return first + second;
            },

            AddSignup: function () {
                this.$router.push('/NewUser')
            },

            getPageSize: function (pageSize, isDesc) {
                
                this.pageSize = pageSize;
                this.isDesc = isDesc;
                this.getPage();
            },
            
            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Contact/UserList?searchTerm=' + search + '&pageNumber=' + currentPage + '&pageSize=' + this.pageSize + '&isDesc=' + this.isDesc + '&submitForApproval=' + true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                            icon: 'error',
                            type: 'error',
                            title: 'Error',
                            text: "Something Went Wrong",
                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });
                }).finally(() => root.loading = false);
            },


            EditInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Contact/UserDetail?id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        root.$router.push({
                            path: '/KycApproved',
                            query: { data: response.data }
                        })
                    }
                });
            },
        },
        created: function () {
            
        },
        mounted: function () {
            this.GetData(this.search, 1);
        },
    }
</script>